
    import { Component, Prop, Vue } from "vue-property-decorator";
    import FormGroup from "@/UI/components/common/form/FormGroup.vue";

    import ClientGeneralForm from "@/form/clientGeneral/clientGeneral";
    import { Button, Menu, List, Table, Select, DatePicker } from "ant-design-vue";
    import moment from "moment";

    @Component({
        components: { FormGroup,
          "a-select": Select,
          "a-select-option": Select.Option,
          "a-date-picker": DatePicker,
        },
        methods: { moment },
    })
    export default class ClientGeneralFormComponent extends Vue {
        @Prop() readonly form!: ClientGeneralForm;
        async created(): Promise<void> {}
        // filterOption(input: string, option: any): any {
        //   return (
        //       option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        //   );
        // }
        handleBirthDateChange(value: any): void {
            this.form.birthday_date = value.format("DD.MM.YYYY");
        }
    }
